export default __webpack_public_path__ + "static/logo-with-text-white-fd63e095be0396a01d87cbacbffe64e2.svg";